import { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext(null);

const THEME_CLASS_NAMES = ["primary", "secondary", "primemedicaltheme"];

export default ({ children }) => {
    // theme: "primary" (pink), "secondary" (Trivalley), "primemedicaltheme" (Prime Medical / PrimeMedicalTheme)
    const [theme, setTheme] = useState("primary");

    useEffect(() => {
        const body = document.body;
        THEME_CLASS_NAMES.forEach((name) => body.classList.remove(name));
        body.classList.add(theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    )
}
